module.exports = __webpack_public_path__ + "img/bill_logo.d07c63c0.png";